import { ref } from 'vue';
import http from './http'

export default function useMyProfile() {
    const loading = ref(false);
    const data = ref();
    const showGetStartedModal = ref(false);
    const signatureFile = ref(null);
    const signaturePad = ref(null);

    function read() {
        loading.value = true;
        http.request('get', '/api/app/business/read').then((res) => {
            if (res?.Type == 200) {
                data.value = res.Data;

                //data.value.SamePhone = data.value.Phone == data.value.AltPhone;
                //data.value.SameEmail = data.value.Email == data.value.AltEmail;

                window.$core.data.Business.Business = data.value;
                window.$core.setBusiness(data.value);
                window.$core.setUserInfo(window.$core.data.UserInfo);

                if (data.value.userId == 0) {
                    showGetStartedModal.value = true;
                }
            }
        }).finally(() => {
            loading.value = false;
        });
    }

    function onSave( callback ) {
        loading.value = true;
        let _this = this;
        console.log("onSave", data.value);
        http.request("put", '/api/app/business/update', data.value).then(res => {
            if (res?.Type == 200) {

                if (callback) {
                    callback(res);
                }
                //window.$message.success('Profile Saved');

                read();//refresh
            } else {

                if (callback) {
                    callback(res);
                }
                //window.$message.error(res?.Content);

            }
        }).finally(() => {
            loading.value = false;
        });
    }


    function saveLogo(file) {
        loading.value = true;

        //console.log("upload Logo", file);

        //var file = signatureFile.value.files[0];
        if (file?.length) {
            return;
        }

        http.request("post", '/api/cloud/upload', file).then(res => {

            if (res?.Data != null) {
                console.log("upload Logo result", res?.Data);
                data.value.Photo = res.Data;
                onSave();
                
            }
        }).finally(() => {
            loading.value = false;
        });
    }

    function onSaveSignatureUpload(file) {
        loading.value = true;

        //console.log("onSaveSignatureUpload", file);

        //var file = signatureFile.value.files[0];
        if (file?.length) {
            return;
        }

        http.request("post", '/api/cloud/upload', file).then(res => {
 
            if (res?.Data != null) {
              
                data.value.Signature = res.Data;
                onSave();
                signatureFile.value = null;
            }
        }).finally(() => {
            loading.value = false;
        });
    }

    function onSaveSignaturePad(file, callback) {
        loading.value = true;
        if (file?.size <= 0) {
            return;
        }
        //console.log("onSaveSignaturePad", file);
        http.request("post", '/api/cloud/upload', file).then(res => {
            if (res?.Data != null) {
                data.value.signature = res.Data;
                //onSave();
                if (callback) {
                    callback();
                }
             
                signaturePad.value.onPadClear();
            }
        }).finally(() => {
            loading.value = false;
        });
    }

    function onUpdateStatus(data, callback) {
        loading.value = true;
        
        http.request("post", '/api/app/project/updatestatus', data).then(res => {
            if (res?.Data != null) {
                 
                if (callback) {
                    callback(res?.Data);
                }
 
            }
        }).finally(() => {
            loading.value = false;
        });
    }

    setTimeout(() => {
        read();
    }, 50)

    return { loading, data, showGetStartedModal, signatureFile, signaturePad, read, onSave, onSaveSignatureUpload, onSaveSignaturePad, onUpdateStatus, saveLogo };
}
